import { setSubAgentsFailed, setSubAgentsPending, setSubAgentsSucceed } from './actions';
import { fetchSubAgents } from '../../services';
import { TThunkAction } from '../../types/redux/thunk';

type TGetSubAgentsDesktopRequest = {
  offset?: number;
  search?: string;
};

/**
 * Запрос списка сотрудников по http
 */
export const getSubAgents =
  ({ offset, search }: TGetSubAgentsDesktopRequest): TThunkAction<Promise<void>> =>
  async (dispatch, getState, context) => {
    const { user } = getState();

    dispatch(setSubAgentsPending());

    const response = await fetchSubAgents(context, {
      parameters: {
        offset,
        search,
      },
      user,
    });

    if (response && response.page) {
      dispatch(setSubAgentsSucceed({ page: response.page, subAgentsList: response.subAgentsList || [] }));

      return;
    }

    dispatch(setSubAgentsFailed());
  };
